<template>
    <div>
        <hts-form-autocomplete
            :label="$t('labels.findAreas')"
            :server="serverNode"
            :text="areaName"
            key-id="_id"
            key-label="name"
            key-type="type"
            :placeholder="$t('labels.selectArea')"
            @change="(data:any)=>handleChange(data)"
            @add="handleAddArea" />
    </div>
</template>
<script lang="ts" setup>
import dataForm from './imports/model'

const props = defineProps({
  areaIsSelected: {
    type: Object,
    default: () => {}
  }
})
const serverNode = $url.area.findAreas
const dataFormSelectArea = reactive({ ...dataForm.initValue })
const areaName = ref('')
onMounted(() => {
  if (props.areaIsSelected) {
    Object.assign(dataFormSelectArea, { ...props.areaIsSelected })
    areaName.value = dataFormSelectArea.name
  } else {
    areaName.value = ''
  }
})
const emits = defineEmits(['changeInput', 'showSlideOver'])

const handleChange = (data: any) => {
  emits('changeInput', data)
}
const handleAddArea = () => {
  emits('showSlideOver')
}
</script>
